import * as actionTypes from '../../actions/actionTypes';

const authActionTypes = actionTypes.authActionTypes;

/**
 * Auth reducer: update authorisation (access) token
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function AUTH_authToken(state = null, action) {
	switch (action.type) {
		case authActionTypes.UPDATE_AUTH_TOKEN:
			return action.authToken;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/reducers/reducers/authReducers.js